import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ProfitCenterService } from '../proxy/controlling/controllers/profit-center.service';
import { CompanyCodeService } from '../proxy/controlling/controllers/company-code.service';

FieldBuilder.setNamespace('Controlling');

export const COSTCENTER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CostCenter.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('sapCode', 'Entity.CostCenter.SapCode')
    .required()
    .minLength(1)
    .maxLength(20)
    .build(),
  FieldBuilder
    .checkbox('isVisible', 'Entity.CostCenter.IsVisible')
    .build(),
  FieldBuilder
      .foreignKey('profitCenterId', 'Entity.CostCenter.ProfitCenter', ProfitCenterService)
      .required()
      .displayFromNested('profitCenter.sapCode')
      .sortBy('profitCenter.sapCode')
      .build(),
  FieldBuilder
      .foreignKey('companyCodeId', 'Entity.CostCenter.CompanyCode', CompanyCodeService)
      .required()
      .displayFromNested('companyCode.name')
      .sortBy('companyCode.name')
      .build(),
];

export const COSTCENTER_CONFIG = {
  entityName: 'CostCenter',
  localizationKey: 'Controlling::Entity.CostCenter',
  fields: COSTCENTER_FIELDS,
  permission: 'ControllingSap.CostCenters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
